module.exports = __webpack_public_path__ + "static/media/expressiveBeachVibes-large.193a9ac4.jpg";